import { render, staticRenderFns } from "./finreceivablesimp.vue?vue&type=template&id=0b76a3eb&scoped=true&"
import script from "./finreceivablesimp.vue?vue&type=script&lang=js&"
export * from "./finreceivablesimp.vue?vue&type=script&lang=js&"
import style0 from "./finreceivablesimp.vue?vue&type=style&index=0&id=0b76a3eb&lang=scss&scoped=true&"
import style1 from "./finreceivablesimp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b76a3eb",
  null
  
)

export default component.exports